import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  footer: {
    flex: '0 1 auto',
    borderTop: `1px solid ${theme.evPalette.charcoal[400]}`,
    height: 'fit-content',
    backgroundColor: theme.evPalette.salt[100],
    display: 'flex',
    alignItems: 'center',
    padding: '10px',
    zIndex: 200,
    position: 'relative',
    '@media (max-width: 675px)': {
      position: 'relative',
      bottom: '0px',
      borderTop: 'none',
      flexWrap: 'wrap',
      padding: '0px 24px 0px 24px',
    },
    '& >*': {
      fontFamily: theme.typography.fontFamily,
      fontSize: '10px',
      fontWeight: 400,
      lineHeight: '12px',
      letterSpacing: 0,
      textAlign: 'left',
      color: theme.evPalette.charcoal[800],
    },
  },
  footerLinksContainer: {
    width: '100%',
    whiteSpace: 'nowrap',
    color: theme.evPalette.charcoal[900],
    '& a': {
      textDecoration: 'none',
      color: theme.evPalette.ocean[600],
    },
    marginRight: '30px',
    '@media (min-width: 675px)': { width: 'fit-content' },
    '@media (max-width: 675px)': { padding: '10px' },
  },
  footerDisclaimerContainer: {
    width: '100%',
    '@media (min-width: 675px)': {
      width: 'auto',
      flex: '1 1 0',
    },
  },
  text: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '10px',
    fontWeight: 400,
    lineHeight: '12px',
    letterSpacing: 0,
    textAlign: 'left',
    color: theme.evPalette.charcoal[800],
  },
  section: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    '@media (max-width: 675px)': {
      padding: '0px 10px 10px 10px',
    },
  },
  content: {
    '@media (max-width: 675px)': {
      maxHeight: '13px',
      /* Initially show only one line */
      transition: 'max-height 0.3s ease',
      /* Smooth transition */
    },
    flex: '1 1 0',
    lineHeight: 0.5,
    overflow: 'hidden',
  },
}));
